/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, BoxView } from '@components/atoms'
import { Grid, ItemColumns } from '@grid'

import {
	useAppSelector,
	useAppDispatch,
	ApiGetDataStatus,
	productActions,
} from '@redux/index'
import { ProductType } from '@schemas'
import { GridRowModel, GridRenderCellParams } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const ItemPage = () => {
	const reduxDispatch = useAppDispatch()
	const navigate = useNavigate()

	// redux state
	const productList: ProductType[] = useAppSelector(state => state.product.products)
	const status: ApiGetDataStatus = useAppSelector(state => state.coupon.couponListStatus)

	const toOneZero = (value: number | boolean) => {
		if (typeof value === 'boolean') {
			return value ? 1 : 0
		}
		return value
	}

	const onAction = (iudFlag: string, aRow: GridRowModel) => {
		const newData = {
			iudFlag: iudFlag as 'I' | 'U' | 'D',
			id: aRow['id'],
			name: aRow['name'],
			code: aRow['code'],
			usd: aRow['usd'],
			krw: aRow['krw'],
			discountUsd: aRow['discountUsd'],
			discountKrw: aRow['discountKrw'],
			quantity: aRow['quantity'],
			index: aRow['index'],
			useYn: toOneZero(aRow['useYn']),
			alwaysAvailableYn: toOneZero(aRow['alwaysAvailableYn']),
			soldoutYn: toOneZero(aRow['soldoutYn']),
		}
		reduxDispatch(productActions.UPDATE_ITEM({ ...newData }))
	}

	return (
		<View css={style}>
			<BoxView title="상시판매 관리">
				<Grid
					title="상시판매 관리"
					rows={productList}
					columns={ItemColumns}
					loading={status === 'loading'}
					onAction={onAction}
					renderCell={
						{
							// Add any custom cell rendering if needed
						}
					}
					renderEditCell={
						{
							// Add any custom edit cell rendering if needed
						}
					}
				/>
			</BoxView>
		</View>
	)
}

export default ItemPage

const style = css({})
